v<template>
  <v-slide-y-transition mode="out-in">
    <div id="coa-forms" style="margin-top: -20px">
      <v-container grid-list-xl fluid>
        <v-layout row wrap>
          <v-flex lg12>          
            <v-card pa-0>  
              <v-toolbar dense cad :class="getColor(fm.tingkat_id)" dark>
                <v-toolbar-title class="title">Form Administrasi</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn v-if="!isUpdate" @click="save(isUpdate)" color="success">Create</v-btn>
                <v-btn v-else @click="save(isUpdate)" color="primary">Save</v-btn> 
                <v-btn v-if="fm.user_id && fm.id" class="cyan" :loading="completeLoading" @click="completeAdministrasi()">Complete</v-btn>
              </v-toolbar>
              <v-divider></v-divider>
              <v-card-text>
                <v-container grid-list-lg class="pa-0 ma-0">
                  <h3 class="text-xs-left mt-0">Form Signin</h3>          
                  <v-layout row wrap style="border:1px solid #eee;"> 
                    <v-flex lg3 md3 sm6 xs12>
                      <v-text-field box
                        v-bind:prefix="isUpdate?'':'+62'" 
                        v-bind:placeholder="isUpdate?'':'812'" 
                        append-icon="phone" 
                        label="phone" 
                        type="text" 
                        v-model="fm.user.phone"                
                        data-vv-name="phone"   
                        v-validate="'required'"
                        :error-messages="errors.collect('phone')"                  
                      ></v-text-field> 
                    </v-flex>
                    <v-flex lg3 md3 sm6 xs12>
                      <v-text-field box
                        append-icon="person" 
                        label="username" 
                        type="text" 
                        v-model="fm.user.username"                
                        data-vv-name="username"   
                        v-validate="'required'"
                        :error-messages="errors.collect('username')"                  
                      ></v-text-field> 
                    </v-flex>                    
                    <v-flex lg3 md3 sm6 xs12>
                      <v-text-field box
                        append-icon="password" 
                        label="password" 
                        type="text" 
                        v-model="fm.user.password"
                        :append-icon="showpass ? 'visibility' : 'visibility_off'"                    
                        :type="showpass ? 'text' : 'password'"
                        @click:append="showpass = !showpass"
                      ></v-text-field> 
                    </v-flex>
                    <v-flex lg3 md3 sm6 xs12>
                      <v-switch 
                        v-bind:label="fm.user.status === 10 ? 'Status Active' : 'Status Inactive'" 
                        v-bind:true-value="10"
                        v-bind:false-value="0"                   
                        v-model="fm.user.status">                      
                      </v-switch>
                    </v-flex>
                  </v-layout>  
                  <h3 class="text-xs-left mt-4">Data Siswa</h3>
                  <v-layout row wrap style="border:1px solid #eee;">                    
                    <v-flex lg10 md10 sm10 xs12>
                      <v-layout row wrap>
                        <v-flex lg6 xs12>
                          <v-radio-group label="mendaftar :" v-model="fm.tingkat_id" row v-validate="'required'" data-vv-name="tingkat_id" :error-messages="errors.collect('tingkat_id')">
                            <v-radio label="SD"  :value="1"></v-radio>
                            <v-radio label="SMP" :value="2"></v-radio>
                            <v-radio label="MA" :value="3"></v-radio>                            
                          </v-radio-group>
                        </v-flex>
                        <v-flex lg6 xs12>
                          <v-radio-group label="Jurusan :" v-model="fm.jurusan_id" row  v-if="fm.tingkat_id === 3" v-validate="'required'" data-vv-name="jurusan_id" :error-messages="errors.collect('jurusan_id')">
                            <v-radio label="IPA"  :value="4"></v-radio>
                            <v-radio label="IPS" :value="5"></v-radio>
                            <v-radio label="AGAMA" :value="6"></v-radio>
                          </v-radio-group>
                        </v-flex>
                        <v-flex lg3 md4 sm4 xs12>
                          <v-text-field box
                            append-icon="person" 
                            label="nama siswa" 
                            type="text" 
                            v-model="fm.nama"                    
                            data-vv-name="nama"
                            v-validate="'required'"
                            :error-messages="errors.collect('nama')"                      
                          ></v-text-field>  
                        </v-flex>
                        <v-flex lg3 md3 sm6 xs12>
                          <v-radio-group label="gender :" v-model="fm.gender" row
                            data-vv-name="gender" v-validate="'required'"    
                            :error-messages="errors.collect('gender')">
                            <v-radio label="L" :value="1"></v-radio>
                            <v-radio label="P" :value="2"></v-radio>            
                          </v-radio-group>
                        </v-flex>                        
                        <v-flex lg3 md3 sm3 xs12>
                          <v-text-field box
                            append-icon="child_care" 
                            label="tempat lahir" 
                            type="text" 
                            v-model="fm.lahir_tempat"                    
                            data-vv-name="lahir_tempat"     
                            v-validate="'required'"
                            :error-messages="errors.collect('lahir_tempat')"                      
                          ></v-text-field>  
                        </v-flex>
                        <v-flex lg3 md3 sm3 xs12>
                          <v-menu                                 
                            ref="birthdate" lazy
                            v-bind:close-on-content-click="false"                        
                            transition="scale-transition"
                            offset-y full-width
                            v-bind:nudge-bottom="-22"
                            max-width="290px"
                            v-bind:return-value.sync="fm.lahir_tanggal"                        
                          >
                            <v-text-field
                              clearable box
                              slot="activator"
                              label="tanggal lahir"
                              v-model="fm.lahir_tanggalV"
                              append-icon="event"
                              readonly             
                              data-vv-name="lahir_tanggal"
                              v-validate="'required'"
                              :error-messages="errors.collect('lahir_tanggal')"
                            ></v-text-field>
                            <v-date-picker v-model="fm.lahir_tanggal" no-title scrollable>                                      
                            </v-date-picker>
                          </v-menu>
                        </v-flex>                         
                      </v-layout>
                    </v-flex>            
                    <v-flex lg2 md2 sm2 xs12 v-if="fm.user_id">                      
                      <div style="max-height:150px; border:1px solid #aaa; position: relative" >                        
                        <img :src="imgUrl ? imgUrl : require('@/assets/img/avatar.png')" style="max-width:100%; max-height:150px;" />
                        <v-progress-circular
                          style="position:absolute; left:5px; top:10px"
                          v-if="imgLoading"
                          :size="130"
                          :width="12"
                          color="info"
                          indeterminate                  
                        ></v-progress-circular>  
                        <v-btn @click="cropshow=true" fab absolute dark small bottom style="right:0px; cursor:pointer" class="yellow"><v-icon>edit</v-icon></v-btn>  
                      </div>
                      <h3 class="text-xs-center mt-2">Pas Foto</h3>
                    </v-flex>

                    <v-flex lg5 md5 sm6 xs12>
                      <v-text-field box
                        append-icon="home" 
                        label="alamat" 
                        type="text" 
                        v-model="fm.alamat"                
                        data-vv-name="alamat"   
                        v-validate="'required'"
                        :error-messages="errors.collect('alamat')"                  
                      ></v-text-field>  
                    </v-flex>
                    <v-flex lg7></v-flex>
                    <v-flex lg2 md2 sm3 xs12>
                      <v-autocomplete box
                        v-bind:items="provinsis"
                        v-bind:filter="customFilter"     
                        v-bind:search-input.sync="provinsiSearch"
                        item-text="nama"
                        item-value="id"
                        v-model="fm.provinsi_id"
                        label="provinsi"
                        hide-no-data 
                        v-validate="'required'"
                        data-vv-name="provinsi_id"     
                        :error-messages="errors.collect('provinsi_id')"
                        :loading="provinsiLoading"                
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex lg2 md2 sm3 xs12>
                      <v-autocomplete box
                        v-bind:items="kotas"
                        v-bind:filter="customFilter"     
                        v-bind:search-input.sync="kotaSearch"
                        item-text="nama"
                        item-value="id"
                        v-model="fm.kota_id"
                        label="kota"
                        hide-no-data 
                        data-vv-name="kota_id"
                        v-validate="'required'"
                        :error-messages="errors.collect('kota_id')"
                        :loading="kotaLoading"
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex lg2 md2 sm3 xs12>
                      <v-autocomplete box
                        v-bind:items="kecamatans"
                        v-bind:filter="customFilter"     
                        v-bind:search-input.sync="kecamatanSearch"
                        item-text="nama"
                        item-value="id"
                        v-model="fm.kecamatan_id"
                        label="kecamatan"
                        hide-no-data 
                        data-vv-name="kecamatan_id"
                        v-validate="'required'"
                        :error-messages="errors.collect('kecamatan_id')"
                        :loading="kecamatanLoading"
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex lg2 md2 sm3 xs12>
                      <v-autocomplete box
                        v-bind:items="kelurahans"
                        v-bind:filter="customFilter"     
                        v-bind:search-input.sync="kelurahanSearch"
                        item-text="nama"
                        item-value="id"
                        v-model="fm.kelurahan_id"
                        label="kelurahan"
                        hide-no-data 
                        data-vv-name="kelurahan_id"  
                        v-validate="'required'"
                        :error-messages="errors.collect('kelurahan_id')"
                        :loading="kelurahanLoading"
                      ></v-autocomplete>
                    </v-flex>
                  </v-layout>
                  <h3 class="text-xs-left mt-4">Sekolah Asal</h3>          
                  <v-layout row wrap style="border:1px solid #eee;">    
                    <v-flex lg5 md5 sm6 xs12>
                      <v-text-field box
                        append-icon="domain" 
                        label="nama sekolah*" 
                        type="text" 
                        v-model="fm.sekolah_nama"                
                      ></v-text-field>  
                    </v-flex>
                    <v-flex lg4 md4 sm6 xs12>
                      <v-text-field box
                        append-icon="fingerprint" 
                        label="NIS*" 
                        type="text" 
                        v-model="fm.sekolah_nis"                
                      ></v-text-field>  
                    </v-flex>
                    <v-flex lg2 md2 sm6 xs12></v-flex>
                    <v-flex lg2 md2 sm3 xs12>
                      <v-autocomplete box
                        v-bind:items="provinsis"
                        v-bind:filter="customFilter"     
                        v-bind:search-input.sync="sekolahProvinsiSearch"
                        item-text="nama"
                        item-value="id"
                        v-model="fm.sekolah_provinsi_id"
                        label="provinsi*"
                        hide-no-data 
                        :loading="sekolahProvinsiLoading"
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex lg2 md2 sm3 xs12>
                      <v-autocomplete box
                        v-bind:items="sekolahKotas"
                        v-bind:filter="customFilter"     
                        v-bind:search-input.sync="sekolahKotaSearch"
                        item-text="nama"
                        item-value="id"
                        v-model="fm.sekolah_kota_id"
                        label="kota*"
                        hide-no-data 
                        :loading="sekolahKotaLoading"
                      ></v-autocomplete>
                    </v-flex>
                     <v-flex lg2 md2 sm3 xs12>
                      <v-autocomplete box
                        v-bind:items="sekolahKecamatans"
                        v-bind:filter="customFilter"     
                        v-bind:search-input.sync="sekolahKecamatanSearch"
                        item-text="nama"
                        item-value="id"
                        v-model="fm.sekolah_kecamatan_id"
                        label="kecamatan*"
                        hide-no-data 
                        :loading="sekolahKecamatanLoading"
                      ></v-autocomplete>
                    </v-flex>
                  </v-layout>
                  <h3 class="text-xs-left mt-4">Data Orang Tua</h3>          
                  <v-layout row wrap  style="border:1px solid #eee;">              
                    <v-flex lg3 md3 sm6 xs12>
                      <v-text-field box
                        append-icon="email" 
                        label="email" 
                        type="text" 
                        v-model="fm.email"
                        data-vv-name="email"     
                        v-validate="'required'"
                        :error-messages="errors.collect('email')"                 
                      ></v-text-field>
                    </v-flex>
                    <v-flex lg3 md4 sm6 xs12>
                      <v-text-field box
                        append-icon="phone" 
                        label="telepon/hp" 
                        type="text" 
                        v-model="fm.telepon"
                        data-vv-name="telepon"    
                        v-validate="'required'"
                        :error-messages="errors.collect('telepon')"                  
                      ></v-text-field>
                    </v-flex>
                    <v-flex lg3 md4 sm6 xs12>
                      <v-text-field box
                        append-icon="phone" 
                        label="whatsapp" 
                        type="text" 
                        v-model="fm.whatsapp"               
                      ></v-text-field>
                    </v-flex>
                    <v-flex lg3></v-flex>
                    <v-flex lg5 md6 sm6 xs12>
                      <v-layout row wrap>
                        <v-flex lg8 xs12>
                          <v-text-field box
                            append-icon="face" 
                            label="Nama Ayah" 
                            type="text" 
                            v-model="fm.ayah_nama"
                            data-vv-name="ayah_nama"
                            v-validate="'required'"
                            :error-messages="errors.collect('ayah_nama')"                      
                          ></v-text-field>
                        </v-flex>
                        <v-flex lg6 xs12>           
                          <v-select box
                            :items="pekerjaans"
                            v-model="fm.ayah_pekerjaan"
                            label="Pekerjaan Ayah"
                            data-vv-name="ayah_pekerjaan"    
                            v-validate="'required'"
                            :error-messages="errors.collect('ayah_pekerjaan')"                      
                          ></v-select>
                        </v-flex>
                        <v-flex lg5 xs12>           
                          <v-select box
                            :items="penghasilans"
                            v-model="fm.ayah_penghasilan"
                            label="Penghasilan Ayah"
                            data-vv-name="ayah_penghasilan"   
                            v-validate="'required'"
                            :error-messages="errors.collect('ayah_penghasilan')"                     
                          ></v-select>
                        </v-flex>
                      </v-layout>            
                    </v-flex>
                    <v-flex lg1></v-flex>
                    <v-flex lg5 md6 sm6 xs12>
                      <v-layout row wrap>
                        <v-flex lg8 xs12>            
                          <v-text-field box
                            append-icon="face" 
                            label="Nama Ibu" 
                            type="text" 
                            v-model="fm.ibu_nama"
                            data-vv-name="ibu_nama"     
                            v-validate="'required'"
                            :error-messages="errors.collect('ibu_nama')"                      
                          ></v-text-field>
                        </v-flex>
                        <v-flex lg6 xs12>           
                          <v-select box
                            :items="pekerjaans"
                            v-model="fm.ibu_pekerjaan"
                            label="Pekerjaan Ibu"
                            data-vv-name="ibu_pekerjaan"   
                            v-validate="'required'"
                            :error-messages="errors.collect('ibu_pekerjaan')"                      
                          ></v-select>
                        </v-flex>
                        <v-flex lg5 xs12>           
                          <v-select box
                            :items="penghasilans"
                            v-model="fm.ibu_penghasilan"
                            label="Penghasilan Ibu"                    
                            data-vv-name="ibu_penghasilan"
                            v-validate="'required'"
                            :error-messages="errors.collect('ibu_penghasilan')"                      
                          ></v-select>
                        </v-flex>
                      </v-layout>  
                    </v-flex>
                    <v-flex lg4 md6 sm6 xs12>
                      <v-select box
                        :items="penghasilans"
                        v-model="fm.pengeluaran"
                        label="Pengeluaran Keluarga/Bulan"
                        data-vv-name="pengeluaran"     
                        v-validate="'required'"
                        :error-messages="errors.collect('pengeluaran')"                  
                      ></v-select>
                    </v-flex>
                  </v-layout>
                  <h3 class="text-xs-left mt-4">Prestasi Siswa (*jika ada)</h3>          
                  <v-layout row wrap style="border:1px solid #eee;">    
                    <v-flex xs12 class="pa-0">
                      <div class="v-table__overflow tabular">
                        <v-btn @click="newPrestasi()" icon class="primary--text mb-2" style="position: absolute; right:15px; " ><v-icon>add</v-icon></v-btn>                                           
                        <v-data-table
                          v-bind:headers="prestasi.headers"
                          v-bind:items="fm.calonPrestasis"
                          hide-actions class="elevation-1 tabular" 
                        >
                          <template slot="items" slot-scope="props" >
                            <td style="width:1%">{{props.index+1}}</td>
                            <td style="width:180px">
                              <v-select
                                solo hide-details  
                                v-bind:items="prestasi.types"
                                v-model="props.item.type"
                                label="Kategori"    
                                item-text="name"
                                item-value="id"  
                              ></v-select>                            
                            </td>                          
                            <td>
                              <v-text-field
                                solo hide-details
                                type="text"
                                v-model="props.item.description"
                                label="(exp : Juara 1 OSN Cab.Matematika Tingkat Nasional)"      
                                style="with:250px"                              
                              ></v-text-field>                            
                            </td>
                            <td style="width:250px">
                              <v-text-field
                                solo hide-details
                                type="file"
                                v-model="props.item.file"
                                label="file"    
                                style="with:250px"                             
                              ></v-text-field>                            
                            </td>
                            <td style="width:1%">                                    
                              <v-btn v-on:click="delPrestasi(props)" icon class="pink--text" small>
                                <v-icon>delete</v-icon>
                              </v-btn>
                            </td>   
                          </template>  
                        </v-data-table>
                      </div>  
                    </v-flex>                   
                  </v-layout>    
                  
                </v-container>
                <crop-upload style="width:100%" field="img"
                  @crop-success="cropSuccess"        
                    :width="300"
                    :height="300"         
                    lang-type="en"
                    :value.sync="cropshow"
                    v-model="cropshow"                
                    img-format="png">            
                </crop-upload> 
              </v-card-text> 
              </v-card-text>       
            </v-card>
          </v-flex>                   
        </v-layout>
      </v-container>
    </div>
  </v-slide-y-transition>
</template>

<script>  
import CropUpload from 'vue-image-crop-upload';  
import Model  from '@/apps/admin/models/Calon';    
import moment from 'moment';

var model = new Model();

export default {
  components : {CropUpload},
  $_veeValidate: {
      validator: 'new'
  },    
  data: () => ({
      showpass:false,
      isEditing:true,
      isUpdate:false,                
      cropshow: false,
      imgUrl : null,
      imgLoading : false,
      saveLoading : false,
      completeLoading : false, 
      prestasi  : {
          types: [
            {id:1, name:'OSN'},
            {id:2, name:'MTQ'},
            {id:3, name:'Hafidz > 3 juz'},
            {id:4, name:'Lainnya'}
          ],
          headers: [            
            { text: 'No', value:'no'},
            { text: 'Kategori', value: 'type'},
            { text: 'Deskripsi', value: 'description'},              
            { text: 'Foto Sertifikat', value:''},
            { text: '', value: '', align:'center', sortable:false },              
          ],          
      }, 
      fm : {
        user : {
            username : null,
            phone : null,
            password : null,
            status : 10,
        },
        user_id : null,
        tingkat_id : null,
        jurusan_id : null,
        nama : null,
        gender : null,
        lahir_tempat : null,
        lahir_tanggal : null,
        lahir_tanggalV : null,
        alamat : null,
        kelurahan_id : null,
        kecamatan_id : null,
        kota_id : null,
        provinsi_id : null,
        prestasi_osn : null,
        prestasi_mtq : null,
        prestasi_hafidz : null,
        prestasi_other : null,
        sekolah_nis : null,
        sekolah_nama : null,
        sekolah_provinsi_id : null,
        sekolah_kota_id : null,
        sekolah_kecamatan_id : null,
        telepon : null,
        whatsapp : null,
        email : null,
        ayah_nama : null,
        ayah_pekerjaan : null, 
        ayah_jabatan : null,
        ayah_penghasilan : null,
        ibu_nama : null,
        ibu_pekerjaan : null, 
        ibu_jabatan : null,
        ibu_penghasilan : null,
        calonPrestasis : [],
      },
      provinsis : [],
      provinsiLoading : false,
      provinsiSearch : null,
      kotaLoading : false,
      kotas : [],   
      kotaSearch : null,
      kecamatanLoading : false,
      kecamatans : [],
      kecamatanSearch : null,
      kelurahanLoading : false,
      kelurahans : [],
      kelurahanSearch : null,
      sekolahProvinsiLoading : false,
      sekolahProvinsis : [],
      sekolahProvinsiSearch : null,
      sekolahKotaLoading : false,
      sekolahKotas : [],
      sekolahKotaSearch : null,
      sekolahKecamatanLoading : false,
      sekolahKecamatans : [],
      sekolahKecamatanSearch : null,
      pekerjaans : ["tidak bekerja", "nelayan", "petani-peternak","guru-dosen","PNS","TNI-POLRI","BUMN","wiraswasta","karyawan","buruh","pensiunan"],
      penghasilans : ["0 sd 2jt","2jt-4jt", "4jt-6jt", "6jt-8jt", "8jt-10jt", "10jt-15jt", "15jt-keatas"]
  }),
 // created () {this.getParents()},    
  mounted () {
    model.tingkats().then(data=>{this.tingkats = data});
    this.$watch(['fm','lahir_tanggal'].join('.'), (val)=>{ if(val){
      this.$refs.birthdate.save(val);
      this.fm.lahir_tanggalV = this.$moment(val).format('DD-MM-YYYY');
    }});     
    this.init(); 
  }, 
  methods : {
    init(){
      if(this.$route.query.id){        
        this.isUpdate   = true;
        model.one({id : this.$route.query.id }).then(data => { 
          if(data.user){
            this.fm.user_id = data.user.id; this.fm.telepon = data.user.phone;      
          }
          Object.assign(this.fm, data === null ? {}:data);
          this.fm.gender = parseInt(this.fm.gender);
          this.fm.tingkat_id = parseInt(this.fm.tingkat_id);
          if(this.fm.user_id)this.getavatar();
        });                                               
      } else {
        this.newPrestasi();
      }            
      this.setProvinsis();
      this.$watch(['fm','provinsi_id'].join('.'), (id)=>{this.kotaLoading = true;
        model.kotas({'KotaSearch[provinsi_id]':id}).then(data=>{this.kotas = data; this.kotaLoading = false;});
      });
      this.$watch(['fm','sekolah_provinsi_id'].join('.'), (id)=>{this.sekolahKotaLoading = true;
        model.kotas({'KotaSearch[provinsi_id]':id}).then(data=>{this.sekolahKotas = data; this.sekolahKotaLoading = false;});
      });
      this.$watch(['fm','kota_id'].join('.'), (id)=>{this.kecamatanLoading = true;
        model.kecamatans({'KecamatanSearch[kota_id]':id}).then(data=>{this.kecamatans = data; this.kecamatanLoading = false;});
      });
      this.$watch(['fm','sekolah_kota_id'].join('.'), (id)=>{this.sekolahKecamatanLoading = true;
        model.kecamatans({'KecamatanSearch[kota_id]':id}).then(data=>{this.sekolahKecamatans = data; this.sekolahKecamatanLoading = false;});
      });
      this.$watch(['fm','kecamatan_id'].join('.'), (id)=>{this.kelurahanLoading = true;
        model.kelurahans({'KelurahanSearch[kecamatan_id]':id}).then(data=>{this.kelurahans = data; this.kelurahanLoading = false;});
      });       
    },
    
    setProvinsis(){
      this.provinsiLoading = true; this.sekolahProvinsiLoading = true;
      model.provinsis().then(data=>{
        this.provinsis = data; this.sekolahProvinsis = data;
        this.provinsiLoading = false; this.sekolahProvinsiLoading = false;
      });
    },
    
    newPrestasi(){
      this.fm.calonPrestasis.push({type : null, description: null, file:null});
    },
    
    delPrestasi(props){            
      this.fm.calonPrestasis.splice(props.index, 1);   
      //this.detail.splice(props.index, 1);   
    },
    
    getColor(tingkat){
      switch(tingkat){case 1:return 'red darken-2'; case 2: return 'indigo'; case 3:return 'blue-grey'; case 7:return 'light-green'; default:return 'black';}
    },

    async save(isUpdate = false) {  
        var FormData = require('form-data');        
        let fmdata   = new FormData();
        let formData = this.convertToFormData(this.fm, fmdata, null);
        var res = isUpdate ? await model.update(formData): await model.create(formData);                
        if(res.status === 200){   
            this.$swal({ type: 'success', title: 'Your work has been saved', showConfirmButton: false, timer: 1000});                
            if(!isUpdate){
              this.$router.push({path:'/signup/calon/form', query:{id:res.data.user_id}});                    
            } else {
              Object.assign(this.fm, res.data);
              this.fm.tingkat_id = parseInt(this.fm.tingkat_id);
              this.fm.gender = parseInt(this.fm.gender);
            }
            //this.$router.go(-1);                    
        } else {
            var title = res.status ? '#'+res.status + ' Oops...' : 'Oops...';
            var text  = res.statusText ? res.statusText: 'Something happened in setting up the request that triggered an Error.';                     
            if(res.data){ if(res.data.message){ text += ' ' + res.data.message; } else {this.validate(res.data);}}                
            this.$swal({type: 'error', title: title, text: text});                    
        }
      //}             
    },
    
    completeAdministrasi(){
      this.$validator.validateAll();
      if( !this.errors.any() ) { 
        this.loading=true;
        var FormData = require('form-data');        
        let fmdata   = new FormData();
        let formData = this.convertToFormData(this.fm, fmdata, null);
        model.completeAdministrasi(formData).then(res=>{
          if(res.status === 200){  
              this.$swal({ type: 'success', title: 'Your work has been saved', showConfirmButton: false, timer: 1000});                
              this.$router.go(-1);
              //this.$router.push({path:'/user', query:{id:res.data.id}});                    
          } else {
              var title = res.status ? '#'+res.status + ' Oops...' : 'Oops...';
              var text  = res.statusText ? res.statusText: 'Something happened in setting up the request that triggered an Error.';                     
              if(res.data){ if(res.data.message){ text += ' ' + res.data.message; } else {this.validate(res.data);}}                
              this.$swal({type: 'error', title: title, text: text});                    
          }
          this.loading=false;
        });          
      }        
    },

    convertToFormData(data, formData, parentKey) {
        if(data === null || data === undefined) return null;
        formData = formData || new FormData();
        if (typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
          Object.keys(data).forEach(key => 
            this.convertToFormData(data[key], formData, (!parentKey ? key : (data[key] instanceof File ? parentKey : `${parentKey}[${key}]`)))
          );
        } else {
          formData.append(parentKey, data);
        }
        return formData;
    },
    
    validate(data){
        data.forEach( (item) => {
            this.$validator.errors.add({field : item.field,msg : item.message});
        });
    },           

    customFilter (item, queryText, itemText) {
        const textOne = item.nama.toLowerCase()
        //const textTwo = item.abbr.toLowerCase()
        const searchText = queryText.toLowerCase()

        return textOne.indexOf(searchText) > -1; 
    },    
      
    cropSuccess(imgDataUrl, field){
      //console.log('-------- crop success --------');
      //this.imgDataUrl = imgDataUrl;

      var block = imgDataUrl.split(";");
      var contentType = block[0].split(":")[1];// In this case "image/gif"
      var realData = block[1].split(",")[1];// In this case "R0lGODlhPQBEAPeoAJosM...."
      var blob = this.b64toBlob(realData, contentType);

      var FormData = require('form-data');
      let formData = new FormData();

      formData.append('image', blob, 'userprofile');
      formData.append('reff_id', this.fm.user_id);
      formData.append('reff_type', 1);        

      this.imgLoading = true;
      model.setavatar(formData).then(res=>{
        this.getavatar();            
      });
    }, 
    
    getavatar(){
      this.imgLoading  = true;
      model.getavatar({reff_id:this.fm.user_id}).then(res=>{
        if(res.data){
          this.imgUrl      = res.data;          
        }
        this.imgLoading  = false;
      });
    },
    
    b64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || '';
      sliceSize = sliceSize || 512;

      var byteCharacters = atob(b64Data);
      var byteArrays = [];

      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          var slice = byteCharacters.slice(offset, offset + sliceSize);

          var byteNumbers = new Array(slice.length);
          for (var i = 0; i < slice.length; i++) {
              byteNumbers[i] = slice.charCodeAt(i);
          }

          var byteArray = new Uint8Array(byteNumbers);

          byteArrays.push(byteArray);
      }

      var blob = new Blob(byteArrays, {type: contentType});
      return blob;
    },  
  }
}
</script>